import { useTranslation } from "react-i18next";
import { LegalPageLayout } from "./LegalPageLayout.tsx";
import { TermsBg } from "./content/TermsBg.tsx";
import { TermsEn } from "./content/TermsEn.tsx";

const contents = { bg: TermsBg, en: TermsEn } as const;

export const TermsPage = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language.split("-")[0] === "bg" ? "bg" : "en";
  const Content = contents[lang];
  return (
    <LegalPageLayout>
      <Content />
    </LegalPageLayout>
  );
};
